export const supportedLanguages: Array<string> = [
  'en',
  'de'
];
